import { render } from "./scenario-fee-settings.vue?vue&type=template&id=3b2d3438&ts=true"
import script from "./scenario-fee-settings.vue?vue&type=script&lang=ts"
export * from "./scenario-fee-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__